<script setup lang="ts">
import useNotificationSequenceInstance from "@/notification-sequences/composables/useNotificationSequenceInstance";
import {
    NotificationSequence,
} from "@/notification-sequences/interfaces/NotificationSequence";
import {computed, reactive} from "vue";
import NotificationSequenceInstanceService from "@/notification-sequences/services/NotificationSequenceInstanceService";
import NotificationSequenceInstanceMessageStatusCell
    from "@/notification-sequences/components/notification-sequence-instances/NotificationSequenceInstanceMessageStatusCell.vue";
import ConsumerAnimationCell from "@/core/components/animation/ConsumerAnimationCell.vue";

const props = defineProps<{
    sequence: NotificationSequence;
}>();

const headers = computed(() => {
    return [
        {
            title: "Patient",
            key: "consumer",
            sortable: false,
            width: "20%"
        },
        {
            title: "Achats",
            key: "sales",
            sortable: false,
            width: "40%"
        },
        ...props.sequence.messages.map((message, index) => {
            return {
                title: `SMS ${index + 1}`,
                key: `message_${index}`,
                sortable: false
            };
        }),
    ];
});

const params = reactive({
    page: 1,
    limit: 10
});

const {data, isValidating} = useNotificationSequenceInstance(props.sequence.id, params);

const handlePageChange = (page: number) => {
    params.page = page;
};

const handleItemPerPageUpdate = (limit: number) => {
    params.page = 1;
    params.limit = limit;
};
</script>

<template>
  <v-data-table-server
    :loading="isValidating"
    :headers="headers" :items="data?.data"
    :items-length="data?.meta?.total ?? 0"
    :items-per-page-options="[10, 20, 30]"
    :items-per-page="params.limit"
    :page="params.page"
    @update:items-per-page="handleItemPerPageUpdate"
    @update:page="handlePageChange"
  >
    <template #[`item.consumer`]="{item}">
      <ConsumerAnimationCell
        :name="item.consumer?.information?.name ?? 'Anonyme'"
        :birth-date="item.consumer?.information?.birth_date"
        :phone="item.customer?.information?.phone"
        :onboarded="item.customer?.onboarded"
        :editable="false"
      />
    </template>
    <template #[`item.sales`]="{item}">
      <p v-if="item.trigger_purchases.length === 0">
        Patient inclus manuellement
      </p>
      <p v-for="(sale, index) in item.trigger_purchases" :key="index">
        {{ sale.product?.name }} - {{ sale.product?.cip }}
      </p>
    </template>
    <template
      v-for="(message, index) in sequence.messages" :key="message.id"
      #[`item.message_${index}`]="{item}"
    >
      <NotificationSequenceInstanceMessageStatusCell
        :message="message"
        :instance-message="NotificationSequenceInstanceService.instanceForSequenceMessage(item.message_instances, message)"
      />
    </template>
  </v-data-table-server>
</template>
